import { useAppDispatch } from '../../effects/useAppDispatch';
import { useAppSelector } from '../../effects/useAppSelector';
import { loanActions } from '../../actions/loan.actions';
import { RightSidePanel } from '../controls/RightSidePanel';
import { EditLoanForm } from './EditLoanForm';

export function LoanMonitorSidePanel() {
    const dispatch = useAppDispatch();
    const activeLoanId = useAppSelector(s => s.loan.activeLoanId);
    const rightSidePanelTab = useAppSelector(s => s.loan.rightSidePanelTab);
    const loan = useAppSelector(s => activeLoanId ? s.loan.loans.find(l => l.id === activeLoanId) : null);

    if (!activeLoanId || !rightSidePanelTab || !loan) {
        return null;
    }

    const handleClose = () => dispatch(loanActions.activeLoanChange());

    const renderTitle = () => {
        return loan.issuerName
    }

    return (
        <RightSidePanel
            className="load-monitor-right-side-panel"
            title={renderTitle()}
            onClose={handleClose}
        >
            <EditLoanForm loan={loan} onCancel={handleClose} />
        </RightSidePanel>
    );
}
